<template>
  <LoaderBox v-if="isLoading" />
  <router-view v-else />
  <div id="toast-container" class="position-fixed bottom-0 end-0 p-3 " style="z-index: 299999"></div>
</template>

<style>
</style>

<script>
import {Tooltip} from 'bootstrap'
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
  name: 'App',
  data() {
    return {
      loading: false,
      Finapp: {
        // PWA Settings
        PWA: {
            enable: true, // Enable or disable PWA
        },
        // Dark Mode Settings
        Dark_Mode: {
            default: false, // Set dark mode as main theme
            local_mode: { // Activate dark mode between certain times of the day
                enable: false, // Enable or disable local dark mode
                start_time: 20, // Start at 20:00
                end_time: 7, // End at 07:00
            },
            auto_detect: { // Auto detect user's preferences and activate dark mode
                enable: false,
            }
        },
        // Right to Left (RTL) Settings
        RTL: {
            enable: false, // Enable or disable RTL Mode
        },
        // Animations
        Animation: {
            goBack: false, // Go back page animation
        },
        // Test Mode
        Test: {
            enable: true, // Enable or disable test mode
            word: "testmode", // The word that needs to be typed to activate test mode
            alert: true, // Enable or disable alert when test mode is activated
            alertMessage: "Test mode activated. Look at the developer console!" // Alert message
        }
      },
      pageBody: document.querySelector("body"),
      // ws: null,
      // networks: {
      //   balances: [],
      //   deposit: [],
      // },
      // options: {
      //   currencies: [],
      // },
      total: {
        balance: 0,
        amount: 0,
      }
    };
  },
  computed: {
    ...mapGetters(['isLoading']),
    ...mapState(['networks', 'currencies', 'assets']),
  },
  // Ciclo de vida: cuando se monta el componente
  async mounted() {
    console.log('App:mounted: El componente ha sido montado.');
    // this.removeModalBackdrop()
    this.loadDarkMode();
    
    // const networksBalances = await this.networksBalancesAPI();
    // console.log('networksBalances', networksBalances)
    // this.networks.balances = networksBalances.networks
    
    // this.total.balance = networksBalances.networks.balances.reduce((acumulador, objeto) => acumulador + objeto.balance, 0);
    // console.log('this.total.balance', this.total.balance)
    // this.total.amount = networksBalances.networks.reduce((acumulador, objeto) => acumulador + objeto.amount, 0);

    // const networksDeposit = await this.networksDepositAPI();
    // console.log('networksDeposit', networksDeposit)
    // this.networks.deposit = networksDeposit.networks

    // const currencies = await this.currenciesAPI();
    // this.options.currencies = currencies.currencies
  },
  methods: {
    ...mapActions(['networksBalancesAPI', 'currenciesAPI', 'networksDepositAPI']),
    
    recortarCadena(cadena) {
        // Verifica si la longitud de la cadena es mayor a 10 caracteres
        if (cadena.length > 10) {
            // Obtiene los primeros 5 caracteres y los últimos 5 caracteres
            const inicio = cadena.slice(0, 5);
            const fin = cadena.slice(-5);
            // Devuelve la cadena recortada con "..."
            return `${inicio}...${fin}`;
        }
    },
    goBackAnimation() {
      this.pageBody.classList.add("animationGoBack")
      setTimeout(() => {
        window.history.go(-1);
        // this.$router.back(); // Cambia esto por router.back()
      }, 300);
    },
    loadInputs() {
      var clearInput = document.querySelectorAll(".clear-input");
      clearInput.forEach(function (el) {
          el.addEventListener("click", function () {
              var parent = this.parentElement
              var input = parent.querySelector(".form-control")
              input.focus();
              input.value = "";
              parent.classList.remove("not-empty");
          })
      })
      // active
      var formControl = document.querySelectorAll(".form-group .form-control");
      formControl.forEach(function (el) {
          // active
          el.addEventListener("focus", () => {
              var parent = el.parentElement
              parent.classList.add("active")
          });
          el.addEventListener("blur", () => {
              var parent = el.parentElement
              parent.classList.remove("active")
          });
          // empty check
          el.addEventListener("keyup", log);
          function log() {
              var inputCheck = this.value.length;
              if (inputCheck > 0) {
                  this.parentElement.classList.add("not-empty")
              }
              else {
                  this.parentElement.classList.remove("not-empty")
              }
          }
      })
    },
    loadToast() {
      let self = this
      //-----------------------------------------------------------------------
      // Toast
      // trigger toast
      var toastCloseButton = document.querySelectorAll(".toast-box .close-button");
      var toastTaptoClose = document.querySelectorAll(".toast-box.tap-to-close");
      // close button toast
      toastCloseButton.forEach(function (el) {
          el.addEventListener("click", function (e) {
              e.preventDefault();
              self.closeToastBox();
          })
      })
      // tap to close toast
      toastTaptoClose.forEach(function (el) {
          el.addEventListener("click", function () {
            self.closeToastBox();
          })
      })
      //-----------------------------------------------------------------------

    },
    closeToastBox() {
      var toastBoxes = document.querySelectorAll(".toast-box");
        toastBoxes.forEach(function (el) {
            el.classList.remove("show")
        })
    },
    toastbox(target, time) {
      let self = this
        var a = document.getElementById(target);
        self.closeToastBox()
        setTimeout(() => {
            a.classList.add("show")
        }, 100);
        if (time) {
            time = time + 100;
            setTimeout(() => {
              self.closeToastBox()
            }, time);
        }
    },
    loadBackButtom() {
      let self = this;
      var goBackButton = document.querySelectorAll(".goBack");
      goBackButton.forEach(function (el) {
          el.addEventListener("click", function () {
              if (self.Finapp.Animation.goBack) {
                self.goBackAnimation();
              }
              else {
                self.$router.back();
              }
          })
      })
    },
    loadSearchBox() {
      //-----------------------------------------------------------------------
      // Searchbox Toggle
      var searchboxToggle = document.querySelectorAll(".toggle-searchbox")
      searchboxToggle.forEach(function (el) {
          el.addEventListener("click", function () {
              var search = document.getElementById("search")
              var a = search.classList.contains("show")
              if (a) {
                  search.classList.remove("show")
              }
              else {
                  search.classList.add("show")
                  search.querySelector(".form-control").focus();
              }
          })
      });
      //-----------------------------------------------------------------------
    },
    loadDarkMode() {
      let self = this
      // Dark Mode
      var checkDarkModeStatus = localStorage.getItem("FinappDarkmode");
      var switchDarkMode = document.querySelectorAll(".dark-mode-switch");
      var pageBodyActive = this.pageBody.classList.contains("dark-mode");

      // Check if enable as default
      if (this.Finapp.Dark_Mode.default) {
        this.pageBody.classList.add("dark-mode");
      }

      // Local Dark Mode
      if (this.Finapp.Dark_Mode.local_mode.enable) {
        var nightStart = this.Finapp.Dark_Mode.local_mode.start_time;
        var nightEnd = this.Finapp.Dark_Mode.local_mode.end_time;
        var currentDate = new Date();
        var currentHour = currentDate.getHours();
        if (currentHour >= nightStart || currentHour < nightEnd) {
          // It is night time
          this.pageBody.classList.add("dark-mode");
        }
      }

      // Auto Detect Dark Mode
      if (this.Finapp.Dark_Mode.auto_detect.enable)
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          this.pageBody.classList.add("dark-mode");
        }

      function switchDarkModeCheck(value) {
        switchDarkMode.forEach(function (el) {
          el.checked = value
        })
      }
      // if dark mode on
      if (checkDarkModeStatus === 1 || checkDarkModeStatus === "1" || this.pageBody.classList.contains('dark-mode')) {
        switchDarkModeCheck(true);
        if (pageBodyActive) {
          // dark mode already activated
        }
        else {
          this.pageBody.classList.add("dark-mode")
        }
      }
      else {
        switchDarkModeCheck(false);
      }
      switchDarkMode.forEach(function (el) {
        el.addEventListener("click", function () {
          var darkmodeCheck = localStorage.getItem("FinappDarkmode");
          var bodyCheck = self.pageBody.classList.contains('dark-mode');
          if (darkmodeCheck === 1 || darkmodeCheck === "1" || bodyCheck) {
            self.pageBody.classList.remove("dark-mode");
            localStorage.setItem("FinappDarkmode", "0");
            switchDarkModeCheck(false);
          }
          else {
            self.pageBody.classList.add("dark-mode")
            switchDarkModeCheck(true);
            localStorage.setItem("FinappDarkmode", "1");
          }
        })
      })
    },
    removeModalBackdrop() {
      var delet = document.querySelectorAll(".modal-backdrop")
      if (delet.length > 0) location.reload();
      // delet.forEach(function (el){
      //   console.log('elm', el)
      //   el.remove()
      // })
    },
    convertirTiempo(minutos) {
      // Calculamos las horas y los minutos
      const horas = Math.floor(minutos / 60);
      const restoMinutos = minutos % 60;
    
      // Creamos un array para almacenar las partes del tiempo
      let resultado = [];
    
      // Agregamos las horas, si hay
      if (horas > 0) {
          if (horas === 1) {
              resultado.push('1 Hora');
          } else {
              resultado.push(`${horas} Horas`);
          }
      }
    
      // Agregamos los minutos, si hay
      if (restoMinutos > 0) {
          if (restoMinutos === 1) {
              resultado.push('1 Minuto');
          } else {
              resultado.push(`${restoMinutos} Minutos`);
          }
      }
    
      // Si no hay horas ni minutos, devolver 0
      if (resultado.length === 0) {
          return '0 Minutos';
      }
    
      // Unimos el resultado con "y" si tiene ambas partes
      return resultado.join(' y ');
    }
  },
  
  // Ciclo de vida: antes de crear el componente
  async beforeCreate() {
    console.log('App:beforeCreate: El componente está a punto de ser creado.');
  },

  // Ciclo de vida: cuando se crea el componente
  async created() {
    console.log('App:created: El componente ha sido creado.');
  },

  // Ciclo de vida: antes de montar el componente
  async beforeMount() {
    console.log('App:beforeMount: El componente está a punto de ser montado.');
  },

  // Ciclo de vida: antes de actualizar el componente
  beforeUpdate() {
    console.log('App:beforeUpdate: El componente está a punto de ser actualizado.');
    console.log('eliminar modals activas')
    this.removeModalBackdrop()
  },

  // Ciclo de vida: cuando se actualiza el componente
  updated() {
    console.log('App:updated: El componente ha sido actualizado.');
    
    // eslint-disable-next-line
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    // eslint-disable-next-line 
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
  },

  // Ciclo de vida: antes de destruir el componente
  beforeUnmount() {
    console.log('App:beforeUnmount: El componente está a punto de ser destruido.');
  },

  // Ciclo de vida: cuando se destruye el componente
  unmounted() {
    console.log('App:unmounted: El componente ha sido destruido.');
  },

  setup() {
    console.log('App:setup: Configuración del componente.');
  },
};
</script>

